export enum InvoiceStatusEnum {
    Due = 'Due',
    Overdue = 'Overdue',
    Paid = 'Paid',
    Void = 'Void',
    WrittenOff = 'WrittenOff',
    Disputed = 'Disputed'
}
